// Exports
export default {
	"feedbackForm": "feedbackForm_VeEEO"
};
